import {
  HardFormFieldTypeEnum,
  HardTableColumnTypeEnum,
  IHardFormField,
  IHardFormFieldParams,
  IHardFormInputParams,
} from "@hardcode-kz/ui";
import { Validators } from "@angular/forms";
import {
  IBaseConfig,
  IFormFieldFilter,
  ITable,
} from "@models/form/base-config";
import { IBusinessPartner } from "@app/shared/data-access/src/lib/resource-management/models/business-partners";
import { BusinessPartnerToggleComponent } from "@modules/admin/modules/dictionary-modules/business-partners/business-partner-toggle/business-partner-toggle.component";
import { ResourceManagementEndpoints } from "@app/shared/data-access/src/lib/resource-management/types/resource-management-endpoints";
import { TranslationFieldPartialValidator } from "@static/fields/fields-constant";
import { LangEnum } from "@models/interface-management/localization";

export class BusinessPartnersConfig implements IBaseConfig {
  version = 1;
  dicType = ResourceManagementEndpoints.BusinessPartner;
  isCrudByModal = true;

  fields: IHardFormField[] = [
    {
      name: "name",
      params: {
        direction: "row",
        fields: TranslationFieldPartialValidator(
          "dicTable.name",
          HardFormFieldTypeEnum.Input,
          [LangEnum.RU, LangEnum.EN, LangEnum.KZ],
        ),
      },
    },
    {
      params: {
        direction: "row",
        fields: [
          {
            name: "description",
            title: "dicTable.description",
            type: HardFormFieldTypeEnum.Input,
          },
        ],
      },
    },
    {
      params: {
        direction: "row",
        fields: [
          {
            name: "bin",
            title: "dicTable.bin",
            type: HardFormFieldTypeEnum.Input,
            params: {
              mask: "000000000000",
            } as IHardFormInputParams,
          },
          {
            name: "country",
            title: "dicTable.country",
            type: HardFormFieldTypeEnum.Input,
          },
        ],
      },
    },
    {
      params: {
        direction: "row",
        fields: [
          {
            name: "city",
            title: "dicTable.city",
            type: HardFormFieldTypeEnum.Input,
          },
          {
            name: "address",
            title: "dicTable.address",
            type: HardFormFieldTypeEnum.Input,
          },
        ],
      },
    },
    {
      params: {
        direction: "row",
        fields: [
          {
            name: "email",
            title: "dicTable.email",
            type: HardFormFieldTypeEnum.Input,
            params: {
              validators: [Validators.required, Validators.email],
            },
          },
          {
            name: "phoneNumber",
            title: "dicTable.phoneNumber",
            type: HardFormFieldTypeEnum.Input,
            placeholder: "+7 777 777 77 77",
            params: {
              mask: "+0 000 000 00 00",
            } as IHardFormInputParams,
          },
        ],
      },
    },
  ];

  filterTemplateColumns = "1fr";

  filterFields: IFormFieldFilter<IHardFormFieldParams>[] = [
    {
      name: "searchTerm",
      type: HardFormFieldTypeEnum.Input,
      placeholder: "base.search",
      outside: true,
    },
  ];

  tableConfig: ITable<IBusinessPartner> = {
    showDefaultActions: true,
    tableColumns: "44px 1fr 1fr 1fr 1fr 1fr 100px 160px auto",
    columns: [
      {
        title: "№",
        name: "id",
        type: HardTableColumnTypeEnum.Index,
      },
      {
        title: "dicTable.name",
        name: "name",
        type: HardTableColumnTypeEnum.Text,
      },
      {
        title: "dicTable.phoneNumber",
        name: "phoneNumber",
        type: HardTableColumnTypeEnum.Text,
      },
      {
        title: "dicTable.email",
        name: "email",
        type: HardTableColumnTypeEnum.Text,
      },
      {
        title: "dicTable.country",
        name: "country",
        type: HardTableColumnTypeEnum.Text,
      },
      {
        title: "dicTable.city",
        name: "city",
        type: HardTableColumnTypeEnum.Text,
      },
      {
        title: "dicTable.isActive",
        name: "isActive",
        type: HardTableColumnTypeEnum.Component,
        component: BusinessPartnerToggleComponent,
      },
      {
        title: "dicTable.createdAt",
        name: "createdAt",
        type: HardTableColumnTypeEnum.Date,
      },
    ],
  };

  saveCallback = (data: IBusinessPartner) => {
    return {
      ...(data.id && { id: data.id }),
      name: data.name,
      number: data.number,
      description: data.description,
      trn: data.trn,
      bin: data.bin,
      country: data.country,
      city: data.city,
      address: data.address,
      email: data.email,
      phoneNumber: data.phoneNumber,
    };
  };
}
